import { useQuery } from 'react-query';
import { companyClosedConsultationsQuery } from './useCompanyClosedConsultations.query';
import { PageQueryParams } from '../../../types/api/api.types';
import { UseCompanyConsultationsResponse } from '../useCompanyConsultations/useCompanyConsultations.types';

export const ALL_COMPANY_CLOSED_CONSULTATIONS_QUERY_KEY = 'ALL_COMPANY_CLOSED_CONSULTATIONS';

export const useCompanyClosedConsultations = (params: PageQueryParams) => {
  return useQuery<UseCompanyConsultationsResponse, Error>(
    ALL_COMPANY_CLOSED_CONSULTATIONS_QUERY_KEY,
    () => companyClosedConsultationsQuery(params),
    {
      retry: false,
    }
  );
};
